import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const hasConsent = () => localStorage.getItem("jt-consent") === "yes";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("jt-consent")) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("jt-cookie-prefs", reopen);
    return () => window.removeEventListener("jt-cookie-prefs", reopen);
  }, []);

  const accept = () => {
    localStorage.setItem("jt-consent", "yes");
    setVisible(false);
    window.dispatchEvent(new Event("jt-consent-accepted"));
  };

  const decline = () => {
    localStorage.setItem("jt-consent", "no");
    setVisible(false);
    window.dispatchEvent(new Event("jt-consent-revoked"));
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-0 inset-x-0 z-[65] bg-[#1C1917]/97 backdrop-blur-xl border-t border-[#C5A059]/25"
        >
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
            <p className="flex-1 text-xs sm:text-sm text-[#C5BCAD] leading-relaxed">
              Cookie tecnici; mappa di Google, pixel di Meta e statistiche di Google Analytics{" "}
              <span className="text-[#F7F4EE]">solo se accetti.</span>{" "}
              <button
                data-testid="cookie-privacy-link"
                onClick={() => window.dispatchEvent(new Event("jt-open-privacy"))}
                className="underline underline-offset-2 text-[#C5A059] hover:text-[#F7F4EE] transition-colors"
              >
                Privacy &amp; Cookie Policy
              </button>
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                data-testid="cookie-decline-button"
                onClick={decline}
                className="px-7 py-2.5 border border-[#F7F4EE]/20 text-[#C5BCAD] text-xs uppercase tracking-[0.2em] hover:border-[#C5A059] hover:text-[#C5A059] transition-colors duration-300"
              >
                Rifiuta
              </button>
              <button
                data-testid="cookie-accept-button"
                onClick={accept}
                className="px-7 py-2.5 bg-[#C5A059] text-[#0D0C0B] text-xs uppercase tracking-[0.2em] hover:bg-[#F7F4EE] transition-colors duration-300"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
